import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { StudiesPage } from './studies';
import { TranslateModule } from '@ngx-translate/core'; // Required for translation.

@NgModule({
  declarations: [
    StudiesPage,
  ],
  imports: [
    IonicPageModule.forChild(StudiesPage),
    TranslateModule.forChild() // Required for translation.
  ],
})
export class StudiesPageModule {}



// WEBPACK FOOTER //
// ./src/pages/studies/studies.module.ts